import React from 'react'
import { HeaderSection } from '../components/Headers/HeaderSection';
import { EXPERIENCE, SKILLS } from '../constant/global';

export default function Resume() {
    return (
        <article className="resume active" data-page="resume">
            <HeaderSection title="Resume" />
            {EXPERIENCE.map((x) => (
                <section className="timeline" key={x.title}>
                    <div className="title-wrapper">
                        <div className="icon-box">
                            {x.icon}
                        </div>
                        <h3 className="h3">{x.title}</h3>
                    </div>
                    <ol className="timeline-list">
                        {x.data.map((x) => (
                            <li className="timeline-item" key={x.title}>
                                <h4 className="h4 timeline-item-title">{x.title}</h4>
                                <span>{x.subTitle}</span>
                                <p className="timeline-text">{x.desc}</p>
                            </li>
                        ))}
                    </ol>
                </section>
            ))}
            <section className="skill">
                <h3 className="h3 skills-title">My skills</h3>
                <ul className="skills-list content-card">
                    {SKILLS.map((x) => (
                        <li className="skills-item" key={x.title}>
                            <div className="title-wrapper">
                                <h5 className="h5">{x.title} |</h5>
                                <data value={x.desc}>{x.desc || x.progress}</data>
                            </div>
                            <div className="skill-progress-bg">
                                <div className="skill-progress-fill" style={{ width: x.progress }} />
                            </div>
                        </li>
                    ))}
                </ul>
            </section>
        </article>
    )
}
